import React from 'react'
import { ChevronRight, Search } from 'lucide-react'

import { useTranslation } from '@/features/locale/LocaleProvider'
import { cn } from '@/lib/utils'

/** Botón de acción para abrir el buscador de tokens (no simula un input de búsqueda). */
export function MobileTokenSearchButton({
  onClick,
  variant = 'prominent',
  className,
}: {
  onClick: () => void
  variant?: 'prominent' | 'tile'
  className?: string
}) {
  const t = useTranslation()
  const copy = t.shell.tokenSearch

  if (variant === 'tile') {
    return (
      <button
        type="button"
        onClick={onClick}
        aria-label={copy.aria}
        className={cn('mobile-app__quick-action-tile', className)}
      >
        <Search className="size-4 shrink-0 text-primary" aria-hidden />
        <span className="mobile-app__quick-action-tile-label">{copy.label}</span>
      </button>
    )
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn('mobile-app__token-search-btn', className)}
      aria-label={copy.aria}
    >
      <span className="mobile-app__token-search-btn-icon-wrap" aria-hidden>
        <Search className="size-5" strokeWidth={2.25} />
      </span>
      <span className="mobile-app__token-search-btn-copy">
        <span className="mobile-app__token-search-btn-title">{copy.title}</span>
        <span className="mobile-app__token-search-btn-sub">{copy.subtitle}</span>
      </span>
      <ChevronRight className="mobile-app__token-search-btn-chevron" aria-hidden />
    </button>
  )
}
